module.exports = "/_next/static/images/11c22e0bea04f81ba09d2dd051a05ab5-purple-pig-icon.svg.webp";